import BaseService from "./base.service";
import { API_ENDPOINTS } from "@iso/constants/apiEndpoints.constant";
import { ACCESS_TOKEN_KEY } from "@iso/constants/common.constant";
import { baseURL } from "./axios.utils";

export default class DownloadService extends BaseService {
  buildUrlDownload = ({ taskId, taskAttachId }) => {
    const url = [
      API_ENDPOINTS.TASK_ATTACH_DOWNLOAD.replace("{taskId}", taskId),
      taskAttachId,
      "&jwt=",
      localStorage.getItem(ACCESS_TOKEN_KEY),
    ].join("");

    return `${baseURL}${url}`;
  };

  deleteAttach = ({ taskId, taskAttachId, typeAttach }) => {
    if (typeAttach === null || typeAttach === undefined) {
      typeAttach = "";
    }
    return this.axios.delete(
      API_ENDPOINTS.TASK_ATTACH_DELETE
          .replace("{taskId}", taskId)
          .replace("{taskAttachId}", taskAttachId)
          .replace("{typeAttach}", typeAttach)
    );
  };

  deleteExtraAttach = ({ taskAttachId, typeTask }) => {
    return this.axios.delete(
      API_ENDPOINTS.TASK_EXTRA_ATTACH_DELETE
          .replace("{taskAttachId}", taskAttachId)
          .replace("{typeTask}", typeTask)
    );
  };

  buildUrlDownloadNote = ({ taskAttachId }) => {
    const url = [
      API_ENDPOINTS.DOWNLOAD_TASK_ATTACH_FILE_NOTE.replace("{taskAttachId}", taskAttachId),
      "?jwt=",
      localStorage.getItem(ACCESS_TOKEN_KEY),
    ].join("");

    return `${baseURL}${url}`;
  };

  resolveAttachImageUrl = (attach) => {
    if (attach && attach.presignedUrl) return attach.presignedUrl;
    if (attach && attach.taskId != null && attach.taskAttachId != null) {
      return this.buildUrlDownload({ taskId: attach.taskId, taskAttachId: attach.taskAttachId });
    }
    if (attach && attach.taskAttachId != null) {
      return this.buildUrlDownloadNote({ taskAttachId: attach.taskAttachId });
    }
    return undefined;
  };

  fetchPresignedUrl = ({ taskId, taskAttachId }) => {
    return this.axios.get(
      API_ENDPOINTS.TASK_ATTACH_PRESIGNED_URL
        .replace("{taskId}", taskId)
        .replace("{attachId}", taskAttachId)
    );
  };
}
